import { field } from '@cerebral/forms'

function isValidFieldFactory(fieldPath) {
  function isValidField({ state, path, resolve }) {
    const fieldValue = resolve.value(field(fieldPath))
    return fieldValue.isValid
      ? path.true()
      : path.false({
          failedRule: fieldValue.failedRule
            ? fieldValue.failedRule.name
            : 'isRequired'
        })
  }

  return isValidField
}

export default isValidFieldFactory



// WEBPACK FOOTER //
// ./src/modules/Media/factories/isValidField.js